import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { TimezonesStoreService } from '@core/stores/timezones-store.service';
import { Timezone } from '@app/shared/models/timezone.model';

@Injectable()
export class TimezonesResolverService {
    constructor(private timezonesStoreService: TimezonesStoreService) {}

    resolve(): Observable<Timezone[]> {
        return this.timezonesStoreService.setTimezones();
    }
}
